import React from "react";

import type { ChildProps as Props } from "./EmbeddedContent";

const shadowMode = "closed";

export const ShadowEmbedder = ({ content }: Props): JSX.Element | null => {
  const shadowRef = React.useRef<HTMLTemplateElement>(null);
  const parentRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!parentRef.current || !shadowRef.current) return;

    const shadowRoot = parentRef.current.attachShadow({ mode: shadowMode });
    shadowRoot.appendChild(shadowRef.current.content);
    shadowRef.current?.remove();
  }, []);

  return (
    <div ref={parentRef}>
      {/* 
          We need to encapsulate the template in a div as that div is what the
          shadow root is actually attached to. We use the declarative shadow
          root here in order to get ssr support
          */}
      <template
        ref={shadowRef}
        // @ts-ignore: type system doesn't know about declarative shadowRoot
        shadowroot={shadowMode}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </div>
  );
};
